/* eslint-disable @typescript-eslint/no-explicit-any */
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, map, Observable } from 'rxjs';
import { CountriesJson, CurriculumResponse, HobbiesResponse, MajorResponse, Nationality, Settings, StudyLevelResponse } from '../models/common.model';
import { environment } from '../../environments/environment';
import { StudentUserResponse } from '../models/auth.model';

@Injectable({
  providedIn: 'root'
})
export class CommonService {

  selectedLanguage: BehaviorSubject<string | null> = new BehaviorSubject<string | null>('en');

  settingsSubject: BehaviorSubject<Settings | null> = new BehaviorSubject<Settings | null>(null);

  constructor(private http: HttpClient) { }

  removeEmptyKeys(obj: any): any {
    return Object.fromEntries(
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      Object.entries(obj).filter(([_, value]) => value !== null && value !== undefined && value !== '')
    );
  }

  removeEmptyKeysOne(obj: any): any {
    return Object.fromEntries(
      Object.entries(obj)
        .map(([key, value]) => [key, value && typeof value === 'object' ? this.removeEmptyKeys(value) : value]
        )
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        .filter(([_, value]) => value !== null && value !== undefined && value !== '' && 
          (typeof value !== 'object' || Object.keys(value).length > 0)
        )
    );
  }

  getCountries(): Observable<Array<CountriesJson>> {
    return this.http.get<Array<CountriesJson>>('assets/countryLangJson/countries.json');
  }

  getCities(country: string): Observable<any> {
    return this.http.get<any>('assets/countryLangJson/city.json').pipe(
      map((data: any[]) => {
        return data.find((item) => item.country === country);
      })
    );
  }

  getNationality(): Observable<Array<Nationality>> {
    return this.http.get<Array<Nationality>>('assets/countryLangJson/nationality.json');
  }

  getLanguages(country: string): Observable<any> {
    return this.http.get<any>('assets/countryLangJson/languages.json').pipe(
      map((data: any[]) => {
        return data.find((item) => item.country === country);
      })
    );
  }

  getAllLanguages(): Observable<any> {
    return this.http.get<any>('assets/countryLangJson/allLanguages.json').pipe(
      map(res => res));
  }

  getHobbies(): Observable<HobbiesResponse> {
    return this.http.get<{data: HobbiesResponse}>(`${environment.base_url}hobbies`).pipe(map(res => res.data));
  }

  getStudyLevels(query?: string): Observable<StudyLevelResponse> {
    const url = query ? `${environment.base_url}studyLevels?${query}` : `${environment.base_url}studyLevels`;
  
    return this.http.get<{ data: StudyLevelResponse }>(url).pipe(
      map(res => res.data)
    );
  }

  getCurriculum(): Observable<CurriculumResponse> {
    return this.http.get<{data: CurriculumResponse}>(`${environment.base_url}curriculam`).pipe(map(res => res.data));
  }

  getMajors(): Observable<MajorResponse> {
    return this.http.get<{data: MajorResponse}>(`${environment.base_url}major`).pipe(map(res => res.data));
  }

  getUserById(id: string): Observable<StudentUserResponse> {
    return this.http.get<{data: StudentUserResponse}>(`${environment.base_url}user/getUserById?id=${id}`).pipe(map(res => res.data));
  }

}
